import React from "react"
import SbEditable from "storyblok-react"

import Components from "../components/components.js"

const GlobalFormEditable = ({ blok }) => {
  return (
    <SbEditable content={blok}>
      {blok.form && blok.form.content ? (
        React.createElement(Components(blok.form.content.component), {
          key: blok.form.content._uid,
          blok: {
            ...blok.form.content,
            currentLanguage: blok.currentLanguage,
            seoLinks: blok.seoLinks,
          },
        })
      ) : (
        <div></div>
      )}
    </SbEditable>
  )
}

export default GlobalFormEditable
